export default __webpack_public_path__ + "static/media/cover7.db3225e7.jpg";